import React from "react";
import { useAuth } from "@shadowhealth/oidc-login";
import { useParams, Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Card, CardContent, Link as MuiLink, Stack, Typography } from "@mui/material";
import PipelineTable from "../components/PipelineTable";

const ScriptPage = () => {
  const auth = useAuth();
  const { scriptName } = useParams();

  return (
    <Stack spacing={3}>
      <Card>
        <CardContent>
          <Stack spacing={1}>
            <Breadcrumbs aria-label="breadcrumb">
              <MuiLink component={RouterLink} underline="hover" color="inherit" to="/scripts">
                Scripts
              </MuiLink>
              <Typography color="text.primary">{scriptName}</Typography>
            </Breadcrumbs>
            <Typography variant="h5" component="h1">
              {scriptName}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <PipelineTable
            auth={auth}
            scriptName={scriptName}
            pipelinesEndpoint={"/pipelines"}
            scriptsEndpoint={"/scripts"}
          />
        </CardContent>
      </Card>
    </Stack>
  );
};

export default ScriptPage;
